// src/components/UploadMenuPage.js

import React, { useState } from "react";
import { ref, uploadBytes } from "firebase/storage";
import { addDoc, collection } from "firebase/firestore";
import { storage, db } from "../firebase";
import "./UploadMenuPage.css";

const UploadMenuPage = () => {
  const [pageNumber, setPageNumber] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleFileChange = (e) => {
    setImageFile(e.target.files[0]);
    setErrorMsg("");
    setSuccessMsg("");
  };

  const handlePageNumberChange = (e) => {
    setPageNumber(e.target.value);
    setErrorMsg("");
    setSuccessMsg("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!pageNumber || isNaN(pageNumber) || Number(pageNumber) <= 0) {
      setErrorMsg("Please enter a valid page number.");
      return;
    }
    if (!imageFile) {
      setErrorMsg("Please select an image file.");
      return;
    }

    setUploading(true);
    setErrorMsg("");
    setSuccessMsg("");

    try {
      // 1. Create a Storage reference under "menuPages/<pageNumber>-<originalFilename>"
      const fileExtension = imageFile.name.split(".").pop();
      const storagePath = `menuPages/${String(pageNumber).padStart(2, "0")}-${Date.now()}.${fileExtension}`;
      const storageRef = ref(storage, storagePath);

      // 2. Upload the file
      await uploadBytes(storageRef, imageFile);

      // 3. Add a Firestore document in "menuPages" with { pageNumber, imagePath }
      await addDoc(collection(db, "menuPages"), {
        pageNumber: Number(pageNumber),
        imagePath: storagePath,
      });

      setSuccessMsg(`Page ${pageNumber} uploaded successfully!`);
      setPageNumber("");
      setImageFile(null);
      // Reset file input value
      document.getElementById("menu-image-input").value = "";
    } catch (err) {
      console.error("Upload error:", err);
      setErrorMsg("Failed to upload. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="upload-page-container">
      <h2>Upload New Menu Page</h2>
      <form className="upload-form" onSubmit={handleSubmit}>
        <label htmlFor="page-number-input">Page Number</label>
        <input
          id="page-number-input"
          type="number"
          min="1"
          value={pageNumber}
          onChange={handlePageNumberChange}
          placeholder="e.g. 1"
        />

        <label htmlFor="menu-image-input">Select Image</label>
        <input
          id="menu-image-input"
          type="file"
          accept="image/*"
          onChange={handleFileChange}
        />

        {errorMsg && <div className="error-text">{errorMsg}</div>}
        {successMsg && <div className="success-text">{successMsg}</div>}

        <button type="submit" disabled={uploading}>
          {uploading ? "Uploading…" : "Upload Page"}
        </button>
      </form>
    </div>
  );
};

export default UploadMenuPage;
